import { EmptyState, FlexBox } from '@airship-platform/jam-web/components';
import { Link as RouterLink } from 'react-router';
import { SectionWrapper } from '../../../patterns';
import OptionDocumentCard from './documents-section/OptionDocumentCard';
import { useDocuments } from './documents-section/useDocuments';

const DocumentsPage: React.FC = () => {
  const { acceptedOptions } = useDocuments();

  return (
    <SectionWrapper
      maxWidth={'md'}
      header="Documents"
      actionsButtons={{
        left: {
          color: 'softGold',
          component: RouterLink,
          to: '../service-menu',
          label: 'Close',
        },
      }}
    >
      {acceptedOptions.length === 0 ? (
        <EmptyState
          title="No documents available yet"
          subtitle="Documents become available once an option has been accepted. Once an option is sold, you'll be able to download proposal PDFs, work orders, and other relevant documents here."
        />
      ) : (
        <FlexBox flexDirection="column" gap={3} width="100%">
          {acceptedOptions.map((option) => (
            <OptionDocumentCard
              key={option.appointmentProposalOptionId}
              option={option}
            />
          ))}
        </FlexBox>
      )}
    </SectionWrapper>
  );
};

export default DocumentsPage;
